import { numericUtil } from '@cmg/common';
import type { INumberFilterParams } from '@cmg/data-grid';
import { createValueFormatter } from '@cmg/data-grid';
import isNil from 'lodash/isNil';

import type { CalendarGridColDef, CalendarGridRowData } from '../../CalendarGrid.model';
import { filterNumberMillionFormatter, filterNumberMillionParser } from '../../CalendarGrid.model';

export type Value = NonNullable<CalendarGridRowData['attributes']>['marketCapAtPricingUsd'];

export const valueFormatter = createValueFormatter<CalendarGridRowData, Value>({
  gridRow: ({ value }) => {
    if (isNil(value)) {
      return '-';
    }

    return numericUtil.formatCurrencyInMillions(value, true);
  },
});

const marketCapPostOfferingUsdColDef: CalendarGridColDef<Value> = {
  field: 'attributes.marketCapAtPricingUsd',
  headerName: 'Market Cap Post-Offering ($M) ⓘ',
  headerTooltip:
    'Market Cap in USD is calculated using the exchange rate on the later of filing or launch date.',
  width: 153,
  type: ['numericColumn', 'number'],
  valueFormatter,
  filter: 'agNumberColumnFilter',
  filterParams: {
    defaultOption: 'inRange',
    filterOptions: [
      'inRange',
      'equals',
      'notEqual',
      'lessThan',
      'lessThanOrEqual',
      'greaterThan',
      'greaterThanOrEqual',
    ],
    includeBlanksInRange: true,
    includeBlanksInEquals: true,
    includeBlanksInNotEqual: true,
    includeBlanksInGreaterThan: true,
    includeBlanksInLessThan: true,
    inRangeInclusive: true,
    numberFormatter: filterNumberMillionFormatter,
    numberParser: filterNumberMillionParser,
  } satisfies INumberFilterParams,
};

export default marketCapPostOfferingUsdColDef;
